/* unplugin-vue-components disabled */import { render } from "./treasureList.vue?vue&type=template&id=4b523b97&scoped=true"
import script from "./treasureList.vue?vue&type=script&lang=js"
export * from "./treasureList.vue?vue&type=script&lang=js"

import "./treasureList.vue?vue&type=style&index=0&id=4b523b97&scoped=true&lang=scss"
import "./treasureList.vue?vue&type=style&index=1&id=4b523b97&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b523b97"]])

export default __exports__